import React, { useState } from 'react';
import { View, Text, TextInput, StyleSheet, TouchableOpacity } from 'react-native';
import { MainColors } from '../../../../constants/Colors';
import FontSizes from '../../../../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import ChoiceCard from '../../../../components/ChoiceCard';

const ChoiceCardInput = (props) => {
    const [isTitleFocused, setIsTitleFocused] = useState(false);
    const [isExplanationFocused, setIsExplanationFocused] = useState(false);

    return (
        <View>
            <Text style={styles.containerLabel}>Choices</Text>
            {props.choices.length === 0 ? (
                <View style={{ marginBottom: 12 }}>
                    <Text style={styles.noChoicesMessage}>We need stuff to choose from. Add a choice to give the people a voice!</Text>
                </View>
            ) : (
                    props.choices.map(choice => (
                        <View style={styles.listItemContainer}>
                            <ChoiceCard
                                key={choice.choiceId}
                                createMode={true}
                                disabled={true}
                                choiceTitle={choice.choiceTitle}
                                choiceExplanation={choice.choiceExplanation}
                                onDeleteChoicePressed={() => props.onDeleteChoicePressed(choice)}
                                choiceDeleteButtonDisabled={props.choiceDeleteButtonDisabled}
                            />
                        </View>
                    ))
                )
            }

            {props.choiceInputControlVisible ? (
                <>
                    <View style={styles.choiceCardContainer}>
                        <View style={styles.titleContainer}>
                            <Text style={[styles.label, isTitleFocused ? styles.focusedLabel : styles.unFocusedLabel]}>Title</Text>
                            <TextInput
                                multiline={true}
                                style={[styles.textInput, isTitleFocused ? styles.focusedInput : styles.unfocusedInput]}
                                placeholder="Yes"
                                value={props.choiceTitleValue}
                                onChangeText={props.onChangeChoiceTitle}
                                onFocus={() => setIsTitleFocused(true)}
                                onBlur={() => setIsTitleFocused(false)}
                                accessibilityLabel={"Enter choice title (i.e. yes, no, agree, disagree...)"}
                            />
                        </View>
                        <View style={styles.explanationContainer}>
                            <Text style={[styles.label, isExplanationFocused ? styles.focusedLabel : styles.unFocusedLabel]}>
                                Explanation (optional)
                            </Text>
                            <TextInput
                                multiline={true}
                                style={[styles.textInput, isExplanationFocused ? styles.focusedInput : styles.unfocusedInput]}
                                placeholder="Voting yes means..."
                                value={props.choiceExplanationValue}
                                onChangeText={props.onChangeChoiceExplanation}
                                onFocus={() => setIsExplanationFocused(true)}
                                onBlur={() => setIsExplanationFocused(false)}
                                accessibilityLabel={"Explain what it means to vote for this choice"}
                            />
                        </View>
                    </View>

                    <TouchableOpacity style={styles.addChoiceButton}
                        disabled={props.choiceTitleValue ? false : true}
                        onPress={props.onAddChoicePressed}>
                        <Text style={props.choiceTitleValue ? styles.addChoiceLabel : styles.disabledAddChoiceLabel}>Add Choice</Text>
                        <MaterialCommunityIcons
                            name="plus-circle-outline"
                            size={20}
                            color={props.choiceTitleValue ? MainColors.primary : MainColors.lightGray}
                        />
                    </TouchableOpacity>
                </>
            ) : (null)}
        </View>
    )
}

const styles = StyleSheet.create({
    containerLabel: {
        fontSize: FontSizes.medium,
        marginBottom: 8,
        paddingLeft: 12,
        color: MainColors.mediumGray,
        fontWeight: '500'
    },
    choiceCardContainer: {
        borderWidth: 2,
        borderColor: MainColors.lightGray,
        borderRadius: 8,
        padding: 10,
        marginBottom: 10,
        flexDirection: 'row'
    },
    titleContainer: {
        width: '40%',
        paddingRight: 5
    },
    explanationContainer: {
        width: '60%',
        paddingLeft: 10,
        borderLeftWidth: 1.2,
        borderLeftColor: MainColors.lightGray
    },
    label: {
        fontSize: FontSizes.medium,
        marginBottom: 8,
        color: MainColors.mediumGray,
    },
    focusedLabel: {
        color: MainColors.primary,
        borderBottomColor: MainColors.primary
    },
    unFocusedLabel: {
        color: MainColors.mediumGray
    },
    focusedInput: {
        width: '100%',
        borderBottomColor: MainColors.primary,
        borderBottomWidth: 2
    },
    unfocusedInput: {
        width: '100%',
        borderBottomColor: MainColors.lightGray,
        borderBottomWidth: 1
    },
    textInput: {
        fontSize: FontSizes.medium,
        paddingBottom: 8,
    },
    listItemContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20
    },
    choiceTitle: {
        fontWeight: '700',
        fontSize: FontSizes.medium,
        color: MainColors.darkGray
    },
    choiceExplanation: {
        fontSize: FontSizes.medium,
        flexWrap: 'wrap',
        color: MainColors.darkGray
    },
    addChoiceButton: {
        color: MainColors.primary,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    addChoiceLabel: {
        fontSize: FontSizes.medium,
        paddingRight: 5,
        color: MainColors.primary,
        fontWeight: '500'
    },
    disabledAddChoiceLabel: {
        fontSize: FontSizes.medium,
        paddingRight: 5,
        color: MainColors.lightGray,
        fontWeight: '500'
    },
    noChoicesMessage: {
        marginLeft: 12,
        fontSize: FontSizes.medium,
        color: MainColors.mediumGray,
    }
});

export default ChoiceCardInput;